var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('textarea',{staticClass:"textarea",class:{ 'textarea--error': _vm.error, 'textarea--disabled': _vm.disabled },attrs:{"id":_vm.id,"placeholder":_vm.placeholder,"disabled":_vm.disabled},domProps:{"value":_vm.value},on:{"input":function($event){return _vm.$emit('input', $event.target.value)},"focus":function($event){return _vm.$emit('focus')},"blur":function($event){return _vm.$emit('blur')}}})}
var staticRenderFns = []

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./src/modules/shared/ui/public/forms/fields/Textarea.vue?vue&type=template&id=809ac9d2&
// module id = 1103
// module chunks = 0